import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import Seo, { SITE } from '../components/Seo'
import seo from './pages.json'

interface PageSeo {
  path: string
  title?: string
  description?: string
  noindex?: boolean
}

const PAGES = new Map<string, PageSeo>((seo.pages as PageSeo[]).map(p => [p.path.toLowerCase(), p]))

/**
 * Default meta for the current route from pages.json. Pages may still render
 * their own <Helmet>/<JsonLd>; react-helmet-async lets the deepest tag win.
 */
export default function RouteSeo (): JSX.Element | null {
  const { pathname } = useLocation()
  const key = pathname.length > 1 ? pathname.replace(/\/+$/, '').toLowerCase() : '/'
  const page = PAGES.get(key)
  if (page === undefined) return null

  if (page.title === undefined || page.description === undefined) {
    // Localised/self-managed pages set their own title + description.
    return (
      <Helmet>
        <link rel="canonical" href={SITE + page.path} />
        <meta property="og:url" content={SITE + page.path} />
      </Helmet>
    )
  }
  return <Seo title={page.title} description={page.description} path={page.path} noindex={page.noindex} />
}
